import { useQuery } from '@tanstack/react-query'
import pick from 'lodash/pick'

import { getCannedTemplateInquiries } from '@/ports'
import { FetchResponse } from '@/ports/api'

import useSessionComplete from './use-session-complete'

type CannedTemplate = { id: string; content: string }

function useInquiryCannedTemplates() {
  const isLoggedIn = useSessionComplete()
  const { data, isLoading } = useQuery(
    [`useInquiryCannedTemplates`],
    () =>
      getCannedTemplateInquiries() as Promise<FetchResponse<CannedTemplate[]>>,
    {
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      retryOnMount: false,
      select: (data: FetchResponse<CannedTemplate[]>) => {
        return pick(data.body[0] ?? {}, ['id', 'content'])
      },
      enabled: isLoggedIn,
      onError: () => {
        return
      }
    }
  )

  return { data, isLoading }
}

export default useInquiryCannedTemplates
